import { IIconProps } from "./types"

export default function IconVec10(props: IIconProps) {
  const width = props.size || props.width || 38
  const height = props.size || props.height || 22
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 38 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9085 16.2558C21.7606 16.7126 17.6005 17.1817 13.286 17.1817C8.97151 17.1817 4.48419 16.7126 2.24362 16.4842C-3.16395e-05 16.2559 0 16.2558 0 16.2558V12H25.9085V16.2558Z"
        fill="#3A3939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.94126C4.20647 1.46908 8.40063 1 12.7768 1C17.1407 1 21.6867 1.46913 23.9519 1.70986C26.2203 1.94132 26.2202 1.94126 26.2202 1.94126V6.30513H0V1.94126Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7744 8V14.9562H30L33.7034 20.9342L37.416 14.9562H34.6416V8H32.7744Z"
        fill="#3A3939"
      />
    </svg>
  )
}
